import { useEffect, useState } from "react";
import { subscribeParaplanningCases } from "../services/paraplanningCasesService";

export const useParaplanningCases = (filters = {}) => {
  const [cases, setCases] = useState([]);
  const [loadingCases, setLoadingCases] = useState(true);
  const [casesError, setCasesError] = useState("");

  useEffect(() => {
    setLoadingCases(true);
    setCasesError("");

    const unsubscribe = subscribeParaplanningCases({
      filters,
      onData: (liveCases) => {
        setCases(liveCases);
        setLoadingCases(false);
      },
      onError: (error) => {
        setCasesError(error.message || "Could not load cases.");
        setLoadingCases(false);
      },
    });

    return () => unsubscribe();
  }, [
    filters.catalogId,
    filters.status,
    filters.monthKey,
    filters.startDate,
    filters.search,
    filters.userEmail,
    filters.isAdmin,
    filters.canManageAllCases,
    filters.assignedTo,
  ]);

  return {
    cases,
    loadingCases,
    casesError,
  };
};
